import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/core/services/local-storage.service';
import { FORCE_REGION } from 'src/app/core/http/http-context.tokens';
import { CoreTargetService } from 'src/app/core/services/target.service';

@Injectable({
  providedIn: 'root',
})
export class PerformanceService {
  constructor(
    private http: HttpClient,
    private localStorageService: LocalStorageService,
    private targetService: CoreTargetService,
  ) {}

  private nudgeOverview = this.localStorageService.get('nudgeOverallSwitcher')
    ? 'nudgeOverview=true'
    : null;

  updateNudgeOverall() {
    this.nudgeOverview = this.localStorageService.get('nudgeOverallSwitcher')
      ? 'nudgeOverview=true'
      : null;
  }

  getBarChartCr(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&target=' +
      data.target +
      '&device=' +
      data.device +
      '&visitType=' +
      data.visitType;

    if (data.outliersSD) {
      params += '&outliersSD=true';
    }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/cr' + params);
  }
  getBarChartAtc(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&target=' +
      data.target +
      '&device=' +
      data.device +
      '&visitType=' +
      data.visitType;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/atc' + params);
  }
  getBarChartRpv(data: any): Observable<any> {
    if (data.noOutliers) {
      if (data.moreThanThreeMonths) {
        var params =
          '?startDate=' +
          data.startDate +
          '&endDate=' +
          data.endDate +
          '&target=' +
          data.target +
          '&device=' +
          data.device +
          '&visitType=' +
          data.visitType +
          // '&noOutliers=' +
          // data.noOutliers +
          '&moreThanThreeMonths=' +
          data.moreThanThreeMonths +
          '&sequences=' +
          data.sequences;
      } else {
        var params =
          '?startDate=' +
          data.startDate +
          '&endDate=' +
          data.endDate +
          '&target=' +
          data.target +
          '&device=' +
          data.device +
          '&visitType=' +
          data.visitType;
        // '&noOutliers=' +
        // data.noOutliers;
      }

      if (data.noOutliers == 's_deviation') {
        params += '&outliersSD=true';
      } else if (data.noOutliers == 's_deviation_3') {
        params += '&outliersSD3=true';
      } else {
        params += '&noOutliers=' + data.noOutliers;
      }
    } else {
      if (data.moreThanThreeMonths) {
        var params =
          '?startDate=' +
          data.startDate +
          '&endDate=' +
          data.endDate +
          '&target=' +
          data.target +
          '&device=' +
          data.device +
          '&visitType=' +
          data.visitType +
          '&moreThanThreeMonths=' +
          data.moreThanThreeMonths +
          '&sequences=' +
          data.sequences;
      } else {
        var params =
          '?startDate=' +
          data.startDate +
          '&endDate=' +
          data.endDate +
          '&target=' +
          data.target +
          '&device=' +
          data.device +
          '&visitType=' +
          data.visitType;
      }
    }

    // if (data.outliersSD) {
    //   params += '&outliersSD=true';
    // }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/rpv' + params);
  }
  getBarChartRr(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&target=' +
      data.target +
      '&device=' +
      data.device +
      '&visitType=' +
      data.visitType;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/rr' + params);
  }
  getBarChartAov(data: any): Observable<any> {
    if (data.noOutliers) {
      var params =
        '?startDate=' +
        data.startDate +
        '&endDate=' +
        data.endDate +
        '&target=' +
        data.target +
        '&device=' +
        data.device +
        '&visitType=' +
        data.visitType;
      // '&noOutliers=' +
      // data.noOutliers;
      if (data.noOutliers == 's_deviation') {
        params += '&outliersSD=true';
      } else if (data.noOutliers == 's_deviation_3') {
        params += '&outliersSD3=true';
      } else {
        params += '&noOutliers=' + data.noOutliers;
      }
    } else {
      var params =
        '?startDate=' +
        data.startDate +
        '&endDate=' +
        data.endDate +
        '&target=' +
        data.target +
        '&device=' +
        data.device +
        '&visitType=' +
        data.visitType;
    }
    // if (data.outliersSD) {
    //   params += '&outliersSD=true';
    // }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/aov' + params);
  }
  getBarChartNsv(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&target=' +
      data.target +
      '&device=' +
      data.device +
      '&visitType=' +
      data.visitType;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/nr' + params);
  }
  // Detailed
  getBarChartDetailedCr(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&incentiveSector=' +
      data.incentiveSector +
      '&siteID=' +
      data.siteID +
      '&ruleID=' +
      data.ruleID +
      '&incentiveTypes=' +
      data.incentiveTypes +
      '&incentives=' +
      data.incentives +
      '&target=' +
      data.target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/detailedcr' + params);
  }
  getBarChartDetailedRpv(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&incentiveSector=' +
      data.incentiveSector +
      '&siteID=' +
      data.siteID +
      '&ruleID=' +
      data.ruleID +
      '&incentiveTypes=' +
      data.incentiveTypes +
      '&incentives=' +
      data.incentives +
      '&target=' +
      data.target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/detailedrpv' + params);
  }
  getBarChartDetailedAov(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&incentiveSector=' +
      data.incentiveSector +
      '&siteID=' +
      data.siteID +
      '&ruleID=' +
      data.ruleID +
      '&incentiveTypes=' +
      data.incentiveTypes +
      '&incentives=' +
      data.incentives +
      '&target=' +
      data.target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/detailedaov' + params);
  }
  getBarChartDetailedRr(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&incentiveSector=' +
      data.incentiveSector +
      '&siteID=' +
      data.siteID +
      '&ruleID=' +
      data.ruleID +
      '&incentiveTypes=' +
      data.incentiveTypes +
      '&incentives=' +
      data.incentives +
      '&target=' +
      data.target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/detailedrr' + params);
  }

  getBarChartDetailedNrv(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&incentiveSector=' +
      data.incentiveSector +
      '&siteID=' +
      data.siteID +
      '&ruleID=' +
      data.ruleID +
      '&incentiveTypes=' +
      data.incentiveTypes +
      '&incentives=' +
      data.incentives +
      '&target=' +
      data.target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/detailednr' + params);
  }

  getAllIncentivesTarget(target: any, returnHTML?: boolean): Observable<any[]> {
    let params = typeof target == 'undefined' ? '' : `?target=${target}`;

    if (returnHTML) {
      params += '&returnHTML=true';
    }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any[]>('/variants' + params);
  }

  downloadOverallReport(data: any) {
    if (data.noOutliers) {
      var params =
        '?target=' +
        data.target +
        '&startDate=' +
        data.startDate +
        '&endDate=' +
        data.endDate +
        '&device=' +
        data.device +
        '&visitType=' +
        data.visitType +
        '&noOutliers=' +
        data.noOutliers +
        '&reportType=' +
        data.reportType;
    } else {
      var params =
        '?target=' +
        data.target +
        '&startDate=' +
        data.startDate +
        '&endDate=' +
        data.endDate +
        '&device=' +
        data.device +
        '&visitType=' +
        data.visitType +
        '&reportType=' +
        data.reportType;
    }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get('/downloadOverallReport' + params, {
      responseType: 'blob',
      observe: 'response',
    });
    //arraybuffer
  }

  downloadDetailedReport(data: any): Observable<any> {
    var params =
      '?target=' +
      data.target +
      '&startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&incentiveSector=' +
      data.incentiveSector +
      '&siteID=' +
      data.siteID +
      '&ruleID=' +
      data.ruleID +
      '&incentiveTypes=' +
      data.incentiveTypes +
      '&incentives=' +
      data.incentives +
      '&reportType=' +
      data.reportType;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get('/downloadDetailedReport' + params, {
      responseType: 'blob',
      observe: 'response',
    });
    //arraybuffer
  }

  getIncentivePerformance(data: any): Observable<any> {
    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&target=' +
      data.target;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/allIncentivePerformance' + params);
  }

  getPerformanceOverview(data: any): Observable<any> {
    const siteID = data.siteID != 'Show All' ? data.siteID : '';
    const active = data.active ? 'active' : 'unactive';

    let params = `?startDate=${data.startDate}&endDate=${data.endDate}&device=${data.device}&target=${data.target}&siteID=${siteID}&active=${active}`;

    if (data.multipleCountries) {
      params += '&multipleCountries=true';
    }
    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/performanceOverview' + params);
  }

  getNudgeDeviceResults(data: {target: string; nudgeId: string; startDate: string; endDate: string; campaignId?: string}): Observable<any> {
    const params = Object.entries(data).filter(([,value]) => value !== undefined)
      .map(([key,value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value!)}`).join('&');
    return this.http.get<any>('/performanceOverview/device-results?' + params);
  }

  getNudgeStatusHistory(target: string, nudgeId: string): Observable<any> {
    return this.http.get<any>(
      `/performanceOverview/status-history?target=${encodeURIComponent(
        target,
      )}&nudgeId=${encodeURIComponent(nudgeId)}`,
    );
  }
  getPerformanceOverviewMultipleCountries(data: any): Observable<any> {
    const siteID = data.siteID != 'Show All' ? data.siteID : '';
    const active = data.active ? 'active' : 'unactive';

    let params = `?startDate=${data.startDate}&endDate=${data.endDate}&device=${data.device}&target=${data.target}&siteID=${siteID}&active=${active}`;

    if (data.multipleCountries) {
      params += '&multipleCountries=true';
    }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>(
      '/performanceOverview/multiple-countries' + params,
    );
  }

  downloadRawData(params: any): Observable<any> {
    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get('/downloadRawData?' + params);
  }

  downloadRawDataDetailed(params: any): Observable<any> {
    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }
    return this.http.get(`/performanceOverview/download?${params}`);
  }

  getVolvoTestDrives(data: any): Observable<any> {
    var params =
      '?target=' +
      data.target +
      '&startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/testDriveCr' + params);
  }
  getPerformanceOverviewNudgeLite(data: any): Observable<any> {
    var siteID = '';
    if (data.siteID != 'Show All') {
      siteID = data.siteID;
    }

    var active = '';
    if (data.active) {
      active = 'active';
    } else {
      active = 'unactive';
    }

    var params =
      '?startDate=' +
      data.startDate +
      '&endDate=' +
      data.endDate +
      '&device=' +
      data.device +
      '&target=' +
      data.target +
      '&siteID=' +
      siteID +
      '&active=' +
      active;

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get<any>('/performanceOverview/table' + params);
  }
  getNudgeLitePlots(obj: any) {
    let params =
      '?startDate=' +
      obj.startDate +
      '&endDate=' +
      obj.endDate +
      '&rate=' +
      obj.rate +
      '&selectedRangeValue=' +
      obj.selectedRangeValue +
      '&target=' +
      obj.target;

    if (obj.device) {
      params += `&device=${obj.device}`;
    }
    if (obj.visitType) {
      params += `&visitType=${obj.visitType}`;
    }

    this.updateNudgeOverall();
    if (this.nudgeOverview) {
      params += `&${this.nudgeOverview}`;
    }

    return this.http.get('/getNudgeLitePlots' + params);
  }

  getAIChatHistory(paramsObj: any): Observable<any> {
    let params: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });
    return this.http.get('/performanceOverview/get-all-chats' + params);
  }

  createAIChat(paramsObj: any): Observable<any> {
    return this.http.post('/performanceOverview/create-chat', paramsObj);
  }

  deleteAIChat(paramsObj: any): Observable<any> {
    let params: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/performanceOverview/delete-chat' + params);
  }

  getAIChat(paramsObj: any): Observable<any> {
    let params: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        params += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/performanceOverview/get-chat' + params);
  }
  askAI(paramsObj: any): Observable<any> {
    return this.http.post('/performanceOverview/ask-ai', paramsObj);
  }
  showMultipleCountries(paramsObj: any): Observable<any> {
    return this.http.post(
      '/privileges/userPrivileges/showMultipleCountries',
      paramsObj,
    );
  }
  getShowMultipleCountries(email: string): Observable<any> {
    return this.http.get(
      '/privileges/userPrivileges/showMultipleCountries?email=' + email,
    );
  }
  nudgesOverall(paramsObj: any, region: string): Observable<any> {
    let query: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        query += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/targetOverall/nudges' + query, {
      context: new HttpContext().set(FORCE_REGION, region),
    });
  }

  getFrequentlyShownTogether(paramsObj: any): Observable<any> {
    let query: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        query += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get(
      '/performanceOverview/frequentlyShownTogether' + query,
    );
  }

  getRaisinInvestmentDashboard(paramsObj: any): Observable<any> {
    let query: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        query += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get('/getRaisinInvestmentDashboard' + query);
  }

  nudgeRevenueLinechart(paramsObj: any): Observable<any> {
    let query: string = '';

    Object.keys(paramsObj).forEach((key, index) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        query += `${index === 0 ? '?' : '&'}${key}=${value}`;
      }
    });

    return this.http.get(
      '/performanceOverview/revenue-uplift-linechart' + query,
    );
  }

  getBehavioralIntelligenceConfig(
    paramTarget?: string | null,
  ): Observable<any> {
    const target =
      paramTarget || this.targetService.getSelectedTarget('target');
    // const target = 'translatetest';
    return this.http.get(`/behavioral-intelligence/config?target=${target}`);
  }

  getBehavioralIntelligenceBars(
    paramsObj: any,
    paramTarget?: string | null,
  ): Observable<any> {
    const target =
      paramTarget || this.targetService.getSelectedTarget('target');
    // const target = 'translatetest';
    let query: string = `target=${target}`;

    Object.keys(paramsObj).forEach((key) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        query += `&${key}=${value}`;
      }
    });

    return this.http.get(`/behavioral-intelligence/bars?${query}`);
  }

  getBehavioralIntelligenceLinechart(paramsObj: any): Observable<any> {
    const target = this.targetService.getSelectedTarget('target');
    // const target = 'translatetest';
    let query: string = `target=${target}`;

    Object.keys(paramsObj).forEach((key) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        query += `&${key}=${value}`;
      }
    });

    return this.http.get(`/behavioral-intelligence/linechart?${query}`);
  }

  getBehavioralIntelligenceSegments(paramsObj: any): Observable<any> {
    const target = this.targetService.getSelectedTarget('target');
    // const target = 'translatetest';
    let query: string = `target=${target}`;

    Object.keys(paramsObj).forEach((key) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        query += `&${key}=${value}`;
      }
    });

    return this.http.get(`/behavioral-intelligence/segments?${query}`);
  }

  getBehavioralIntelligenceSummary(paramsObj: any): Observable<any> {
    const target = this.targetService.getSelectedTarget('target');
    let query: string = `target=${target}`;

    Object.keys(paramsObj).forEach((key) => {
      const value = paramsObj[key];
      if (value !== null && value !== undefined) {
        query += `&${key}=${value}`;
      }
    });

    return this.http.get(`/behavioral-intelligence/summary?${query}`);
  }
}
